module.exports = __webpack_public_path__ + "img/wave.83cfb95f.webp";